// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type GlobeLockIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from globe-lock.svg
 */
export default function GlobeLockIcon(props: GlobeLockIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="GlobeLockIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M15.372 10.303c-.07-1.663-.816-2.364-2.497-2.364-1.726 0-2.5.774-2.5 2.5v.312c0 .173.14.313.313.313h.624c.173 0 .313-.14.313-.313v-.312l.003-.11c.057-.985.248-1.14 1.247-1.14 1.036 0 1.25.214 1.25 1.25v.312c0 .173.14.313.313.313h.624c.173 0 .313-.14.313-.313v-.312zm.624 1.938a.625.625 0 0 0-.621-.552h-5l-.073.004a.625.625 0 0 0-.552.62v3.75l.004.074c.036.31.3.552.621.552h5l.073-.004c.31-.036.552-.3.552-.621v-3.75z"
        />
        <path
          fill="currentColor"
          d="M8.342 16.682a8 8 0 1 1 7.582-9.105 3 3 0 0 0-.166-.17c-.807-.762-1.871-.968-2.883-.968-1.053 0-2.148.233-2.958 1.042-.81.81-1.042 1.905-1.042 2.958v.369a2 2 0 0 0-.308.388 21 21 0 0 0-1.427.009c.093.81.232 1.545.407 2.159.094.327.195.608.297.835l.078.16.078.139c.053-.106.198.61.25.476v1.133l.01.16.004.043q.023.192.078.372M2.91 11.867l.17-.059.248-.075a13 13 0 0 1 1.807-.36l.054.451.054.382a12.6 12.6 0 0 0 .467 2.03 6.02 6.02 0 0 1-2.8-2.37m-.765-4.493.001-.012c.783.285 1.763.504 2.862.645l-.006.379v.606l.006.38c-1.099.14-2.079.36-2.86.645a6 6 0 0 1-.003-2.643m6.59.806.26-.01.005.519-.006.52a26 26 0 0 0-1.988 0A24 24 0 0 1 7 8.69l.006-.518a26 26 0 0 0 1.73.009M8 2.879l-.077.14a5.6 5.6 0 0 0-.375.995 14 14 0 0 0-.408 2.158q.425.019.861.018.436 0 .86-.016a13.7 13.7 0 0 0-.407-2.16 6 6 0 0 0-.297-.835l-.078-.16zm-2.334.281.045-.019c-.23.694-.403 1.51-.521 2.412l-.055.453c-.877-.118-1.641-.288-2.225-.494A6.02 6.02 0 0 1 5.665 3.16m4.625-.019.05.158c.17.548.308 1.168.413 1.843l.058.411.054.453c.877-.118 1.642-.288 2.226-.493a6.03 6.03 0 0 0-2.536-2.254z"
        />
      </g>
    </svg>
  );
}
